module.exports = __webpack_public_path__ + "fonts/location-white.svg?v=7b9b736aed53ebbecf0786b8b285f790";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location-white.svg
// module id = 693
// module chunks = 0